import { useCallback, useEffect, useMemo, useState } from 'react'

const DEFAULT_LIMIT = 1

type Options = {
  limit?: number
  startIndex?: number
}

const useCarousel = (total: number, options?: Options) => {
  const [currentIndex, setCurrentIndex] = useState<number>(options?.startIndex ?? 0)

  const maxSlide = useMemo(() => {
    if (options?.limit) {
      return Math.ceil(total / options.limit)
    }
    return Math.ceil(total / DEFAULT_LIMIT)
  }, [options?.limit, total])

  const prev = useCallback(
    () =>
      setCurrentIndex((prevState) => {
        if (maxSlide && prevState === 0) {
          return maxSlide
        }
        return prevState - 1
      }),
    [maxSlide]
  )

  const next = useCallback(
    () =>
      setCurrentIndex((prevState) => {
        if (maxSlide && prevState >= maxSlide - 1) {
          return 0
        }
        return prevState + 1
      }),
    [maxSlide]
  )

  useEffect(() => {
    if (currentIndex > total - 1) {
      setCurrentIndex(0)
    }
  }, [total, currentIndex])

  return {
    currentIndex,
    setCurrentIndex,
    maxSlide,
    prev,
    next,
  }
}

export { useCarousel }
